// extracted by mini-css-extract-plugin
export default {"root":"teJxhVedI2QYEaUQ6VB7","content":"XXBO8WAWgtNL01pxMyIF"};